module.exports = __webpack_public_path__ + "static/media/web-scraping-process.b332066a.jpg";